import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { assignProjectListAction } from '@/redux/actions/employee';
import { assignProjectList, TAssignProjectListResponse } from '@/services/api/employee';
import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* assignProjectListSaga(action: ActionType<typeof assignProjectListAction.request>): Generator {
  const { materials, companyId, employeeId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(assignProjectList, materials, companyId, employeeId);
    const assignProjectListResponse: TAssignProjectListResponse = response as TAssignProjectListResponse;
    yield put(assignProjectListAction.success(assignProjectListResponse));
    successCallback?.(assignProjectListResponse);
  } catch (err) {
    yield put(assignProjectListAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.assignProjectsEmployeeError');
  }
}
